export const apiHeaders = {
  'X-API-KEY': 'kckw0coogs44ckgs4wkck84o8gcgww0oo0owws0w'
}

export const apiVersion = 2

export const apiBasePath = process.env.NODE_ENV === 'production' ? `https://yokmedios.com/api/v${apiVersion}` : `https://yokmedios.com/api/v${apiVersion}`
